import { Stack, Typography, useTheme } from "@mui/material";
import { ScoreValue } from "src/api/client-api/post/scoreSchema";
import EmptySetIcon from "src/assets/icons/empty-set.svg?react";
import { ScoreService } from "src/context/EntityBasedScore/ScoreService";
import { NumberFormat } from "src/context/NumberFormat";

/* Kilian: It's much more simple for me to copy/paste the code here
    to suit the new needs of the scores and just be able to delete the previous one
    later on.
*/

export type MainScoreProps = {
    score: {
        value: ScoreValue;
        unit: string | undefined;
        precision: number;
    };
    referenceScore: number | undefined;
};

export const MainScore = (props: MainScoreProps) => {
    const theme = useTheme();
    const { score, referenceScore } = props;

    const _displayedScore = score.value !== undefined ? score.value : referenceScore;
    const displayedScore = ScoreService.normalizeScore(_displayedScore ?? null, score.precision).value;
    const isScoreEmpty = !score.value && referenceScore === undefined;

    return (
        <Stack
            direction="column"
            flexBasis="100%"
            sx={{
                flexDirection: "row",
                gap: "10px",
                alignItems: "flex-end",
            }}
        >
            <Stack alignItems="center" gap="12px">
                {isScoreEmpty ?
                    <EmptySetIcon />
                :   <Stack alignItems="center" gap="10px">
                        <Typography variant="number-big">
                            {NumberFormat.formatUserFacingNumber({ value: displayedScore })}
                        </Typography>
                    </Stack>
                }
            </Stack>
            <Typography
                variant="body"
                sx={{
                    color: theme.custom.grey[1400],
                    position: "relative",
                    top: "-8px",
                }}
            >
                {score.unit}
            </Typography>
        </Stack>
    );
};
